import { ConfirmDialog } from "./ConfirmDialog";

type Props = {
  isOpen: boolean;
  onDiscard: () => void;
  onContinue: () => void;
  title: string;
  body: string;
  discardLabel: string;
  continueLabel: string;
};

/**
 * "Unsaved changes" dialog. Thin wrapper over ConfirmDialog so it inherits the
 * exact confirm-modal experience (centered scale-in, danger icon tile, right-
 * aligned actions). Discard is the destructive (red) action; Continue editing
 * is the safe default (outline) and is what Escape/backdrop resolve to.
 */
export function DiscardChangesDialog({
  isOpen,
  onDiscard,
  onContinue,
  title,
  body,
  discardLabel,
  continueLabel,
}: Props) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={title}
      body={body}
      intent="danger"
      confirmLabel={discardLabel}
      cancelLabel={continueLabel}
      onConfirm={onDiscard}
      onCancel={onContinue}
    />
  );
}
